import React from 'react';

interface RevenueDriverIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const RevenueDriverIcon: React.FC<RevenueDriverIconProps> = ({
  width = 16,
  height = 16, // Changed from 18 to 16 to match other icons
  className = ''
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16" // Changed from 0 0 16 18 to 0 0 16 16
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Dollar sign icon from Figma - representing revenue impact */}
      <path
        d="M8.75113 12.86V14.064C8.75113 14.148 8.73713 14.162 8.66713 14.162H7.30913C7.25313 14.162 7.22513 14.134 7.22513 14.05V12.958C6.41313 12.93 5.65713 12.734 5.11113 12.44C5.04113 12.398 5.01313 12.328 5.01313 12.202V10.55C5.01313 10.466 5.08313 10.424 5.13913 10.466C5.96513 11.096 7.01513 11.306 7.77113 11.306C8.56913 11.306 9.11513 11.054 9.11513 10.606C9.11513 10.186 8.76513 9.906 7.57513 9.416C5.62913 8.66 4.99913 7.96 4.99913 6.672C4.99913 5.524 5.79713 4.474 7.23913 4.222V3.13C7.23913 3.06 7.26713 3.046 7.33713 3.046H8.68113C8.76513 3.046 8.77913 3.06 8.77913 3.13L8.82113 4.194C9.46513 4.236 10.1791 4.376 10.5291 4.642C10.5851 4.67 10.5991 4.712 10.5991 4.796V6.378C10.5991 6.462 10.5291 6.49 10.4731 6.448C9.89913 6.028 9.15713 5.762 8.06513 5.762C7.25313 5.762 6.77713 6.056 6.77713 6.476C6.77713 6.882 7.02913 7.12 8.47113 7.708C10.5711 8.534 11.0051 9.402 11.0051 10.466C11.0051 12.048 9.67513 12.72 8.75113 12.86Z"
        fill="#C18300"
      />
    </svg>
  );
};
